/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Create, Request } from 'src/js/common/epics/EpicUtils';
import {
  DELETE_CART_DATA
} from 'src/js/enrol/actions/Actions';
import CartService from 'src/js/services/CartService';


const request: Request<null,string> = {
  type: DELETE_CART_DATA,
  getData: (payload) => CartService.delete(payload),
  processData: () => [],
};

export const EpicDeletCartData = Create(request);